import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ColumnModel } from "../../../models/common.model";
import { Item } from "../../../models/cartable.model";
import Grid from "@mui/material/Grid";

interface InquiryModel {
  data?: Item[];
  totalPrice?: number;
}

const columns: readonly ColumnModel[] = [
  { id: "title", label: " نام کالا " },
  { id: "factorItemGroupTitle", label: " گروه کالا " },
  { id: "quantity", label: " تعداد" },
  {
    id: "unitPrice",
    label: "قیمت واحد (ریال) ",
  },
  {
    id: "offAmount",
    label: "تخفیف (ریال)",
  },
];

export default function FactorItems({ data, totalPrice }: InquiryModel) {
  return (
    <>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer className="tabsScroll"
          style={{
            maxHeight: '250px', overflowY: 'auto', width: '100%',
            direction: 'rtl', paddingRight: '0', paddingTop: '0'
          }}>
          <Table stickyHeader aria-label="sticky table"
            className=" directionRTL"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead style={{ position: '-webkit-sticky', top: '0px' }}>
              {/* style={{ display: 'block' }} */}
              <TableRow >
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont14 fontWeight"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div
              style={{ width: "100%", height: "10px" }}
            ></div>
            <TableBody >
              {/* style={{ position: 'relative', height: '80px', overflow: 'scroll', display: 'block' }} className=" directionRTL" */}
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    className={`${rowIndex % 2 == 0
                      ? "rowTBodyE  borderRight borderLeft"
                      : "rowTBodyO  borderRight borderLeft"
                      }`}
                    hover role="checkbox" tabIndex={-1} key={rowIndex}>
                    {columns.map((column) => {
                      const value = row[column.id as keyof Item];
                      return (
                        <TableCell
                          className="textFont14"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value?.toLocaleString())
                            : value?.toLocaleString()}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Grid container xs={12} style={{
            backgroundColor: '#F6F8F9', border: 'solid 1px #DAE0E4', height: '46px',
            marginTop: '35px', position: 'sticky', bottom: '0px', direction: 'rtl'
          }}>
            <Grid item xs={7} style={{
              borderLeft: 'solid 1px #DAE0E4', direction: "ltr", textAlign: 'justify',
              fontSize: '14px', alignSelf: 'center'
            }}>
              <span className="fontBlueColor" style={{ marginLeft: '10px' }}>جمع مبلغ فاکتور (ریال)</span>
            </Grid>
            <Grid item xs={5} style={{ fontSize: '14px', alignSelf: 'center' }}>
              <span className="fontBlueColor" style={{ marginRight: '20px', fontWeight: 'bold' }}>{totalPrice!.toLocaleString()}</span>
            </Grid>
          </Grid>
        </TableContainer>
      </Paper>
    </>
  );
}
